import { MessageCircle } from "lucide-react";
import { CLINIC } from "@/lib/api";

/**
 * Floating WhatsApp button — mobile only.
 *
 * • Hidden at `lg` (≥ 1024 px) and above — desktop already has the header
 *   phone/WhatsApp links plus the sticky bar.
 * • Positioned above the existing 3-column MobileStickyBar (≈ 64 px tall)
 *   so it does NOT cover it. Extra safe-area padding is applied on iOS
 *   notch devices.
 * • The cookie banner (z-50) still sits above this button on the first
 *   visit; after the visitor accepts/declines, the banner disappears and
 *   the FAB is fully unobstructed.
 * • The click is captured by the existing global `EventTracker`
 *   (document-level capture-phase listener) which fires the GA4
 *   `whatsapp_click` event — no per-button onClick is added, so there is
 *   no duplicate handler. Consent Mode v2 defaults still gate transport.
 * • Uses the shared `CLINIC.whatsapp` URL so every "Scrie pe WhatsApp"
 *   button on the site has the same accessible purpose (Lighthouse a11y).
 */

export default function WhatsAppFab() {
  return (
    <a
      href={CLINIC.whatsapp}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Scrie pe WhatsApp"
      data-testid="whatsapp-fab"
      className="lg:hidden fixed z-40 flex items-center gap-2 rounded-full bg-[#25D366] hover:bg-[#128C7E] text-white shadow-lg shadow-black/20 px-4 py-3 text-sm font-semibold transition-colors"
      style={{
        right: "calc(1rem + env(safe-area-inset-right, 0px))",
        bottom: "calc(5.25rem + env(safe-area-inset-bottom, 0px))",
      }}
    >
      <MessageCircle className="w-5 h-5" aria-hidden="true" />
      <span>Scrie pe WhatsApp</span>
    </a>
  );
}
